import ZaniaIcon from "@/shared/icons/zania";
import { ClipboardList } from "lucide-react";
import { Link } from "react-router-dom";

const GuestSidebar = () => {
  return (
    <div
      className="relative bg-white bg-opacity-50 h-full flex flex-col items-center justify-between text-white"
    >
      <div className="flex-1 w-full">
        <Link to="https://zania.ai/">
          <div
            className={"p-6 flex items-center gap-4"}
          >
            <ZaniaIcon className="w-6 h-6 m-auto" />
          </div>
        </Link>
        <div className="m-auto flex items-center justify-center text-[#7A788E] size-5 mt-4">
          <ClipboardList />
        </div>

      </div>
    </div>
  );
};

export default GuestSidebar;
